import { ReadOnlyFooter, SlidingToggle } from '@components/ui';
import { SpaceBetweenRowContainer } from '@components/ui/container/common';
import { ToggleProps } from '@components/ui/sliding-toggle';
import { Card, CardProps, FormLayout } from '@shopify/polaris';
import { CardSubTitle, CardTitleSmall } from '@ui/common';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { SeparatorContainer } from '../separator';

export type ToggleCardProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  cardProps?: CardProps;
  footerWarningText?: string | React.ReactNode;
  slidingToggleProps: ToggleProps;
  childrenTopPadding?: string;
};

export const ChildrenContainer = styled.div<{
  paddingTop?: string;
}>`
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-bottom: 1.2rem;

  ${SeparatorContainer} {
    margin: 1rem -2rem;
  }
`;

export const ToggleCard: FunctionComponent<ToggleCardProps> = ({
  cardProps,
  children,
  childrenTopPadding,
  footerWarningText,
  slidingToggleProps,
  subtitle,
  title,
}) => {
  return (
    <Card {...cardProps} sectioned>
      <SpaceBetweenRowContainer>
        <CardTitleSmall>{title}</CardTitleSmall>
        <SlidingToggle {...slidingToggleProps} />
      </SpaceBetweenRowContainer>
      {subtitle && <CardSubTitle>{subtitle}</CardSubTitle>}
      <ChildrenContainer paddingTop={childrenTopPadding}>
        <FormLayout>{children}</FormLayout>
      </ChildrenContainer>
      {footerWarningText && <ReadOnlyFooter text={footerWarningText} />}
    </Card>
  );
};

export default ToggleCard;
